<template>
  <div class="title-list" v-if="items.length">
    <div class="title-list__header">
      <b><font face="微软夜黑" style="font-size: 18pt" color="#FFFFFF">{{ title }}</font></b>
    </div>
    <div class="title-list__list">
      <button
        v-for="(item, i) in items"
        :key="i"
        type="button"
        class="title-list__item"
        :class="{ 'is-active': currentIndex === i }"
        @click="openItem(i)"
      >
        <span class="title-list__item-period">{{ issueNumber }}期</span>
        <img class="title-list__item-img bao_image" src="@/images/bao.gif" alt="" />
        <span class="title-list__item-text">
          <span v-if="itemDesc(item)" class="title-list__item-desc">{{ itemDesc(item) }}</span>
          <span class="title-list__item-name" style="color: red">【{{ itemName(item) }}】</span>
        </span>
        <img class="title-list__item-img" src="@/images/az2.gif" alt="" />
      </button>
    </div>

    <div v-if="currentIndex != null" class="title-list__popup" role="dialog" aria-modal="true" @click.self="close">
      <div class="title-list__popup-box">
        <div class="title-list__popup-title">{{ itemDesc(items[currentIndex]) || itemName(items[currentIndex]) }}</div>
        <div v-if="loading" class="title-list__popup-loading">加载中...</div>
        <div v-else-if="currentItems.length" class="title-list__popup-items">
          <div v-for="(it, i) in currentItems" :key="i" class="title-list__popup-item">
            <span class="title-list__popup-item-period">{{ itemPeriod(it) }}期</span>
            <span class="title-list__popup-item-label">【{{ it.labelText }}】</span>
            <span class="title-list__popup-item-content">
              <span
                v-for="(seg, si) in itemContentSegments(it)"
                :key="si"
                :class="{ 'title-list__popup-item-hit': seg.hit }"
              >{{ seg.text }}</span>
            </span>
            <span v-if="it.resultText" class="title-list__popup-item-result">{{ it.resultText }}</span>
          </div>
        </div>
        <div v-else-if="fetched" class="title-list__popup-text">暂无数据</div>
        <img v-else-if="currentIsImage" :src="currentContent" class="title-list__popup-img" alt="" />
        <div v-else class="title-list__popup-text" v-html="currentContent"></div>
        <div class="title-list__popup-actions">
          <button type="button" class="title-list__popup-btn title-list__popup-btn--copy" :disabled="!currentItems.length" @click="copyLatest">{{ copied ? '已复制' : '复制内容' }}</button>
          <button type="button" class="title-list__popup-btn title-list__popup-btn--close" @click="close">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchPredictionItems } from '@/api/prediction'

export default {
  name: 'TitleList',
  props: {
    items: { type: Array, default: () => [] },
    title: { type: String, default: '标题列表' },
    game: { type: String, default: '' }
  },
  data() {
    return {
      currentIndex: null,
      loading: false,
      fetched: false,
      currentItems: [],
      copied: false
    }
  },
  computed: {
    currentItem() {
      return this.currentIndex == null ? null : this.items[this.currentIndex]
    },
    currentContent() {
      const it = this.currentItem
      if (!it) return ''
      if (typeof it === 'string') return it
      return it.content || it.src || ''
    },
    currentIsImage() {
      const c = String(this.currentContent || '').trim()
      return /^https?:\/\/.+(\.jpg|\.jpeg|\.png|\.gif|\.webp)(\?.*)?$/i.test(c)
    },
    issueNumber() {
      const now = new Date()
      let ref = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      if (now.getHours() < 5) {
        ref = new Date(ref.getTime() - 86400000)
      }
      const start = new Date(now.getFullYear(), 0, 1)
      return Math.floor((ref - start) / 86400000) + 1
    },
    site() {
      return process.env.VUE_APP_SITE_ID || 'default'
    },
  },
  watch: {
    currentIndex(val) {
      document.body.style.overflow = val == null ? '' : 'hidden'
    }
  },
  mounted() {
    this._onKeydown = e => { if (e.key === 'Escape' && this.currentIndex != null) this.close() }
    document.addEventListener('keydown', this._onKeydown)
  },
  beforeDestroy() {
    document.body.style.overflow = ''
    document.removeEventListener('keydown', this._onKeydown)
  },
  methods: {
    itemName(item) {
      if (typeof item === 'string') return item
      return item.name || item.title || ''
    },
    itemDesc(item) {
      if (typeof item === 'string') return ''
      return item.desc || item.description || ''
    },
    itemPeriod(it) {
      const p = it && it.period
      return p == null ? '' : String(p).slice(-3)
    },
    itemContentSegments(it) {
      const text = it && it.contentText != null ? String(it.contentText) : ''
      const key = it && it.matchKey != null && String(it.matchKey) !== '' ? String(it.matchKey) : ''
      if (!key || !text) return [{ text, hit: false }]
      const segs = []
      let rest = text
      let idx = rest.indexOf(key)
      while (idx !== -1) {
        if (idx > 0) segs.push({ text: rest.slice(0, idx), hit: false })
        segs.push({ text: key, hit: true })
        rest = rest.slice(idx + key.length)
        idx = rest.indexOf(key)
      }
      if (rest) segs.push({ text: rest, hit: false })
      return segs.length ? segs : [{ text, hit: false }]
    },
    openItem(i) {
      this.currentIndex = i
      this.currentItems = []
      this.fetched = false
      const it = this.items[i]
      const sid = it && it.id
      if (sid == null) return
      this.loading = true
      const params = { site: this.site, sectionId: sid }
      if (this.game) params.game = this.game
      fetchPredictionItems(params)
        .then(res => {
          if (this.currentIndex !== i) return
          const data = res.data
          this.currentItems =
            data && data.code === 200 && data.data && Array.isArray(data.data.items)
              ? data.data.items
              : []
          this.fetched = true
          this.loading = false
        })
        .catch(() => {
          if (this.currentIndex !== i) return
          this.currentItems = []
          this.fetched = true
          this.loading = false
        })
    },
    copyLatest() {
      if (!this.currentItems.length) return
      const items = this.currentItems.slice().sort(
        (a, b) => (Number(b && b.period) || 0) - (Number(a && a.period) || 0)
      )
      const it = items[0]
      const text = it && it.contentText != null ? String(it.contentText) : ''
      const done = () => {
        this.copied = true
        setTimeout(() => { this.copied = false }, 1500)
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(() => this.fallbackCopy(text, done))
      } else {
        this.fallbackCopy(text, done)
      }
    },
    fallbackCopy(text, done) {
      const ta = document.createElement('textarea')
      ta.value = text
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        done()
      } catch (e) {
        /* ignore */
      }
      document.body.removeChild(ta)
    },
    close() {
      this.currentIndex = null
      this.loading = false
      this.fetched = false
      this.currentItems = []
      this.copied = false
    }
  }
}
</script>

<style scoped>
.title-list {
  margin: 0.5rem 0;
  background: #fff;
  border: 1px solid #000000;
  box-shadow: 0 2px 8px rgba(30, 107, 214, 0.08);
  overflow: hidden;
}
.title-list__header {
  border: 8px double #ff9900;
  background: #009900;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.title-list__list {
  display: flex;
  flex-direction: column;
}
.title-list__item {
  width: 100%;
  text-align: left;
  border: none;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
  color: #2d3748;
  font-size: 1rem;
  line-height: 1.5;
  padding: 0.5rem 0.6rem;
  cursor: pointer;
}
.title-list__item-period {
  margin-right: 0.4rem;
  font-size: 0.8rem;
  font-weight: 700;
}
.title-list__item-desc {
  font-size: 0.85rem;
  color: #718096;
}
.title-list__item-img {
  height: 0.8rem;
  width: auto;
  margin-left: 0.2rem;
  vertical-align: middle;
}.bao_image{
  height: 1.1rem;
   margin-left: 0.1rem;
 }
.title-list__item:last-child {
  border-bottom: none;
}
.title-list__item.is-active {
  background: #e8f3fc;
  color: #1e6bd6;
  font-weight: 700;
}
.title-list__popup {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: clamp(0.75rem, 4vw, 1.25rem);
  padding-top: max(clamp(0.75rem, 4vw, 1.25rem), env(safe-area-inset-top));
  padding-bottom: max(clamp(0.75rem, 4vw, 1.25rem), env(safe-area-inset-bottom));
  background: rgba(0, 0, 0, 0.88);
  box-sizing: border-box;
}
.title-list__popup-box {
  width: 100%;
  max-height: min(80vh, calc(100vh - 6rem));
  overflow-y: auto;
  background: #fff;
  border-radius: clamp(0.25rem, 1.5vw, 0.5rem);
  padding: 0.75rem;
  color: #1a1a1a;
  box-sizing: border-box;
}
.title-list__popup-title {
  color: #c00;
  font-size: 1.15rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 0.5rem;
  word-break: break-all;
}
.title-list__popup-actions {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 0.75rem;
  padding-top: 0.6rem;
  border-top: 1px solid #e2e8f0;
  background: #fff;
}
.title-list__popup-btn {
  border: none;
  border-radius: 0.4rem;
  color: #fff;
  font-size: 0.8rem;
  padding: 0.2rem 1rem;
  cursor: pointer;
}
.title-list__popup-btn--copy {
  background: #1e6bd6;
}
.title-list__popup-btn--close {
  background: #94a3b8;
}
.title-list__popup-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.title-list__popup-img {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}
.title-list__popup-text {
  font-size: 0.9rem;
  line-height: 1.5;
  word-break: break-word;
}
.title-list__popup-loading {
  color: #1a1a1a;
  font-size: 1rem;
  text-align: center;
  padding: 0.5rem 0;
}
.title-list__popup-item {
  font-size: 0.95rem;
  line-height: 1.7;
}
.title-list__popup-item + .title-list__popup-item {
  margin-top: 0.2rem;
}
.title-list__popup-item-period {
  font-weight: 700;
  margin-right: 0.3rem;
}
.title-list__popup-item-label {
  font-weight: 700;
  color: #c00;
  margin-right: 0.3rem;
}
.title-list__popup-item-content {
  word-break: break-word;
}
.title-list__popup-item-hit {
  color: #fff;
  background: #e53e3e;
  border-radius: 3px;
  padding: 0 0.15rem;
  font-weight: 700;
}
.title-list__popup-item-result {
  font-weight: 700;
  color: #1e6bd6;
  margin-left: 0.3rem;
}
</style>
